import { useSyncExternalStore } from 'react'

/**
 * The panel shows the maintenance page when either:
 *  1. ops set `VITE_MAINTENANCE_MODE: 'true'` in public/env.js (no rebuild needed), or
 *  2. the API gateway answers 503, which `axiosClient` reports through `reportApiUnavailable`.
 */
let apiUnavailable = false
const listeners = new Set<() => void>()

const isTruthy = (value?: string) => ['1', 'true', 'on'].includes((value ?? '').trim().toLowerCase())

export function isMaintenanceFlagOn(): boolean {
  const runtimeValue = typeof window === 'undefined' ? undefined : window.__FULFILLMENT_PANEL_ENV__?.VITE_MAINTENANCE_MODE
  return isTruthy(runtimeValue ?? import.meta.env.VITE_MAINTENANCE_MODE)
}

export function reportApiUnavailable() {
  if (apiUnavailable) return
  apiUnavailable = true
  listeners.forEach((listener) => listener())
}

const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export type MaintenanceReason = 'flag' | 'api' | null

const getSnapshot = (): MaintenanceReason => (isMaintenanceFlagOn() ? 'flag' : apiUnavailable ? 'api' : null)

export function useMaintenance(): MaintenanceReason {
  return useSyncExternalStore(subscribe, getSnapshot)
}
